module.exports = __webpack_public_path__ + "0b3fed039aa19ac52dd747ab6e497eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logo.png
// module id = 481
// module chunks = 0